
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","d":"M39.63 14.2h-19.8"}}),_c('circle',{staticClass:"cls-1",attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","cx":"13.08","cy":"14.2","r":"2.7"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","d":"M39.63 25h-19.8"}}),_c('circle',{attrs:{"cx":"13.08","cy":"25","r":"2.7","fill":"currentColor","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}}),_c('path',{staticClass:"cls-1",attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","d":"M39.63 35.8h-19.8"}}),_c('circle',{staticClass:"cls-1",attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","cx":"13.08","cy":"35.8","r":"2.7"}})])
          )
        }
      }
    